import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Components/ComponentButton';
import T from '../../../Locale';
import FilesAttachments from './FilesAttachments';
import ImageAttachment from './ImageAttachment';
class PageAttachments extends Component {
    constructor(props) {
        super(props);
        this.state = { isSaving: false, image: false, imageError: false, documentation: [] };
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.save = this.save.bind(this);
    }
    handleFileChange(event) {
        const { files } = event.target;
        const { documentation } = this.state;
        Array.from(files).forEach((file) => {
            documentation.push(file);
        });
        this.setState({ documentation });
    }
    handleImageChange(event) {
        const { files } = event.target;
        let imageUpdated = false;
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png'];
        Array.from(files).forEach((file) => {
            if (allowedTypes.indexOf(file.type) !== -1) {
                this.setState({ image: file, imageError: false });
                imageUpdated = true;
            }
        });
        if (!imageUpdated) {
            this.setState({ imageError: T.translate('values.imageError') });
        }
    }
    save() {
        const { save } = this.props;
        const { image, documentation } = this.state;
        this.setState({ isSaving: true });
        save(image, documentation);
    }
    render() {
        const { imageError, isSaving } = this.state;
        const { data, setData, goToPreviousPage } = this.props;
        return (_jsxs("div", { children: [data.type !== 'saving' && data.type !== 'insurance' && (_jsxs("div", { children: [_jsx("h5", { children: T.translate('values.image') }), _jsx("p", { children: T.translate('values.imageDescription') }), _jsxs("div", Object.assign({ className: "row" }, { children: [data.image && _jsx(ImageAttachment, { image: data.image, setData: setData }), _jsxs("div", Object.assign({ className: "columns" }, { children: [_jsx("input", { type: "file", onChange: (event) => this.handleImageChange(event) }), imageError && _jsx("p", Object.assign({ className: "is-invalid-label" }, { children: _jsx("strong", { children: imageError }) }))] }))] }))] })), _jsx("h5", { children: T.translate('values.documentationHeadline') }), _jsx("p", { children: T.translate('values.documentationDescription') }), _jsx("input", { type: "file", onChange: (event) => this.handleFileChange(event), multiple: true }), _jsx(FilesAttachments, { files: data.files || [], setData: setData }), _jsxs("div", Object.assign({ className: "text-center" }, { children: [_jsx(Button, Object.assign({ classes: "transparent", onClick: goToPreviousPage }, { children: T.translate('misc.previous') })), _jsx(Button, Object.assign({ onClick: this.save, isLoading: isSaving }, { children: T.translate('misc.save') }))] }))] }));
    }
}
PageAttachments.propTypes = {
    data: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    goToPreviousPage: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired
};
export default PageAttachments;
